import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["fileUuid", "fileMimeType", "proxy", "fileName", "file"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import styled, { css } from 'styled-components';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useTranslation } from '@yoweb/next-i18next';
import { getColor, getRadii } from '@yoweb/ui/styles/utils/theme';
import { AddMediaIcon } from '@yoweb/ui/components/Icon/AddMediaIcon';
import { Text } from '@yoweb/ui/components/typography';
import { Flex } from '@yoweb/ui/components/Flex';
import { pxToRem } from '@yoweb/ui/styles/utils';
import { ErrorDisplay } from '@yoweb/ui/components/form';
import { useFileUpload } from '@poplar/hooks/useFileUpload';
import { MediaImage } from '@poplar/components/MediaImage';
import { API_MEDIA_INFO, API_MEDIA_THUMBNAIL } from '@poplar/constants/routes';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { Grid } from '@yoweb/ui/components/Grid';
import { isDocument } from '@poplar/utils/file';
import { getImageThumbnail } from '@poplar/utils/image';
import Spinner from '@yoweb/ui/components/Spinner';
import { MAX_FILES } from '@yoweb/utils/file';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var FileUpload = function FileUpload(_ref) {
  var accept = _ref.accept,
      maxFiles = _ref.maxFiles,
      maxSize = _ref.maxSize,
      maxTotalSize = _ref.maxTotalSize,
      onFileListChange = _ref.onFileListChange,
      initialFiles = _ref.initialFiles,
      _ref$uploadedFileUuid = _ref.uploadedFileUuids,
      uploadedFileUuids = _ref$uploadedFileUuid === void 0 ? [] : _ref$uploadedFileUuid,
      onRemoveUploadedFile = _ref.onRemoveUploadedFile,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useFileUpload = useFileUpload({
    accept: accept,
    maxFiles: maxFiles,
    maxSize: maxSize,
    maxTotalSize: maxTotalSize,
    initialFiles: initialFiles,
    onDragOver: function onDragOver() {
      return setHasFocus(true);
    },
    onDragLeave: function onDragLeave() {
      return setHasFocus(false);
    },
    disabled: disabled
  }),
      getRootProps = _useFileUpload.getRootProps,
      getInputProps = _useFileUpload.getInputProps,
      images = _useFileUpload.images,
      error = _useFileUpload.error,
      removeFile = _useFileUpload.removeFile;

  var _useState = useState(null),
      fileInfoList = _useState[0],
      setFileInfoList = _useState[1];

  var _useState2 = useState(false),
      hasFocus = _useState2[0],
      setHasFocus = _useState2[1];

  useEffect(function () {
    onFileListChange === null || onFileListChange === void 0 ? void 0 : onFileListChange(images); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images]);
  useEffect(function () {
    var fetchFileInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var fileInfos;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(uploadedFileUuids.length > 0)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return Promise.all(uploadedFileUuids.map(function (fileUuid) {
                  return fetchJson("".concat(API_MEDIA_INFO, "/").concat(fileUuid));
                }));

              case 3:
                fileInfos = _context.sent;
                return _context.abrupt("return", setFileInfoList(fileInfos));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchFileInfo() {
        return _ref2.apply(this, arguments);
      };
    }();

    void fetchFileInfo();
  }, [uploadedFileUuids]);

  if (uploadedFileUuids.length > 0 && !fileInfoList) {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(Spinner, {
        size: "md"
      })
    });
  }

  return /*#__PURE__*/_jsxs(Flex, {
    gap: "small3",
    flexDirection: "column",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(StyledFileUpload, _objectSpread(_objectSpread({}, getRootProps()), {}, {
      hasError: !!error,
      hasFocus: hasFocus,
      disabled: disabled,
      children: !disabled && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Flex, {
          gap: "small3",
          justifyContent: "flex-start",
          children: [/*#__PURE__*/_jsx(AddMediaIcon, {
            size: 24
          }), /*#__PURE__*/_jsx(Text, {
            size: "md",
            weight: "bold",
            textDecoration: "underline",
            children: t('file-upload-title')
          })]
        }), /*#__PURE__*/_jsx(Text, {
          size: "md",
          children: t('file-upload-subtitle')
        }), /*#__PURE__*/_jsx("input", _objectSpread({
          "data-testid": "file-input"
        }, getInputProps()))]
      })
    })), !error && /*#__PURE__*/_jsx(Text, {
      size: "sm",
      variant: "muted",
      children: t('file-upload-subtext')
    }), /*#__PURE__*/_jsx(ErrorDisplay, {
      message: error
    }), !disabled && /*#__PURE__*/_jsxs(Grid, {
      columnGap: "normal1",
      rowGap: "normal1",
      columns: "repeat(auto-fill, 108px)",
      as: "ol",
      "data-testid": "file-preview-grid",
      children: [fileInfoList === null || fileInfoList === void 0 ? void 0 : fileInfoList.map(function (_ref3) {
        var uuid = _ref3.uuid,
            fileName = _ref3.fileName,
            fileType = _ref3.fileType;
        return /*#__PURE__*/_jsx(MediaImage, {
          image: {
            src: "".concat(API_MEDIA_THUMBNAIL, "/").concat(uuid)
          },
          fileName: fileName,
          height: 72,
          width: 108,
          borderRadius: "small",
          deleteAction: {
            onDelete: function onDelete() {
              onRemoveUploadedFile === null || onRemoveUploadedFile === void 0 ? void 0 : onRemoveUploadedFile(uuid);
              setFileInfoList(function (prev) {
                return (prev === null || prev === void 0 ? void 0 : prev.filter(function (fileInfo) {
                  return fileInfo.uuid !== uuid;
                })) || [];
              });
            },
            aria: t('file-upload-remove-image-aria')
          },
          isDocument: isDocument(fileType)
        }, uuid);
      }), images.map(function (_ref4, index) {
        var fileUuid = _ref4.fileUuid,
            fileMimeType = _ref4.fileMimeType,
            _ref4$proxy = _ref4.proxy,
            proxy = _ref4$proxy === void 0 ? true : _ref4$proxy,
            fileName = _ref4.fileName,
            file = _ref4.file,
            restImages = _objectWithoutProperties(_ref4, _excluded);

        var imageSrc = getImageThumbnail(_objectSpread({
          fileUuid: fileUuid,
          fileMimeType: fileMimeType,
          proxy: proxy
        }, restImages));
        return /*#__PURE__*/_jsx(MediaImage, {
          image: imageSrc,
          fileName: fileName !== null && fileName !== void 0 ? fileName : file === null || file === void 0 ? void 0 : file.name,
          height: 72,
          width: 108,
          borderRadius: "small",
          deleteAction: {
            onDelete: function onDelete() {
              return removeFile(fileUuid, index);
            },
            aria: t('file-upload-remove-image-aria')
          },
          isDocument: isDocument(fileMimeType)
        }, fileUuid);
      })]
    })]
  });
};
export var getFileUploadInitialValues = function getFileUploadInitialValues(fileAnswer) {
  return {
    fileList: (fileAnswer === null || fileAnswer === void 0 ? void 0 : fileAnswer.answeredValuesList) || [],
    documentsToUpload: (fileAnswer === null || fileAnswer === void 0 ? void 0 : fileAnswer.documentsToUpload) || []
  };
};
export var getFileUploadValidationSchema = function getFileUploadValidationSchema(id, _isOptional) {
  return Yup.object({
    fileList: Yup.array(),
    documentsToUpload: Yup.array()
  }).test('at-least-one-element', '', function (values, ctx) {
    var _ref5 = values,
        fileList = _ref5.fileList,
        documentsToUpload = _ref5.documentsToUpload;

    if (fileList.length === 0 && documentsToUpload.length === 0) {
      return ctx.createError({
        type: 'required',
        message: 'validation.required',
        path: id
      });
    }

    return true;
  });
};
export var FileUploadElement = function FileUploadElement(_ref6) {
  var _values$questionId;

  var instructionHint = _ref6.instructionHint,
      isDisabled = _ref6.isDisabled,
      id = _ref6.id,
      formikProps = _ref6.formikProps;
  var values = formikProps.values,
      setFieldValue = formikProps.setFieldValue;

  var _id$split = id.split('.'),
      _id$split2 = _slicedToArray(_id$split, 2),
      questionId = _id$split2[0],
      index = _id$split2[1];

  var _ref7 = values === null || values === void 0 ? void 0 : (_values$questionId = values[questionId]) === null || _values$questionId === void 0 ? void 0 : _values$questionId[index],
      fileList = _ref7.fileList,
      documentsToUpload = _ref7.documentsToUpload;

  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small2",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), /*#__PURE__*/_jsx(FileUpload, {
      uploadedFileUuids: fileList,
      onRemoveUploadedFile: function onRemoveUploadedFile(fileUuid) {
        return setFieldValue("".concat(id, ".fileList"), fileList.filter(function (fileId) {
          return fileId !== fileUuid;
        }));
      },
      onFileListChange: function onFileListChange(newDocuments) {
        return setFieldValue("".concat(id, ".documentsToUpload"), newDocuments);
      },
      maxFiles: MAX_FILES - fileList.length,
      initialFiles: documentsToUpload,
      disabled: isDisabled
    })]
  });
};
var StyledFileUpload = styled.div.withConfig({
  componentId: "sc-1y01ax5-0"
})(["align-items:center;background-color:", ";border-radius:", ";border:1px dashed;border-color:", ";cursor:pointer;display:flex;flex-direction:column;height:", ";justify-content:center;", " ", ";", ""], getColor('base050'), getRadii('medium'), getColor('base200'), pxToRem(150), function (_ref8) {
  var hasError = _ref8.hasError;
  return hasError && css(["border-color:", ";"], getColor('critical'));
}, function (_ref9) {
  var hasFocus = _ref9.hasFocus;
  return hasFocus && css(["border:2px solid ", ";"], getColor('base900'));
}, function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled && css(["background-color:", ";border:1px dashed ", ";cursor:not-allowed;"], getColor('base100'), getColor('base200'));
});